import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FunctionalErrorComponent } from '@legacy/common-ui-common-renderings';
import { AsyncPipe } from '@angular/common';

import { FunctionalErrorItemPipe } from '../functional-errors.pipe';

@Component({
  selector: 'wl-functional-error-container[key][automationId]',
  templateUrl: './functional-error-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [FunctionalErrorComponent, AsyncPipe, FunctionalErrorItemPipe],
})
export class FunctionalErrorContainerComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() key!: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() automationId!: string;
}
